//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';

type ReadProps = {
  mT?: string;
};

export const TonyWardRWSS24 = ({ mT }: ReadProps) => {
  return (
    <>
      {/* <span style={{ fontSize: '13px', marginTop: mT }}>Haute Couture</span> */}
      <h3 style={{ marginTop: mT }}>TONY WARD</h3>
      <span style={{ fontSize: '13px' }}>Ready-to-Wear Spring / Summer 24</span>
      <div>
        <video
          controls={true}
          controlsList="nodownload"
          playsInline
          muted
          autoPlay
          loop
          style={{ width: '100%', maxWidth: '100%' }}
        >
          <source src={'/media/tonyward_RW_SS_2014.mp4'} type="video/mp4" />
        </video>
      </div>
      <h4>IN THE BEGINNING...</h4>
      {/* <h2>IN AN CHIC LAVISH SUMMER.</h2> */}
      <p className="topPargraph" style={{ margin: 0 }}>
        {/* <b>In the beginning…</b>
        <br /> */}
        The Garden of Eden would be the woman's home. The garden was a paradise,
        full of light and life. Beyond the well-guarded gates of Eden, there was
        a place known only to a few—a realm called Elura. This land mirrored
        Eden in its lushness but differed in its spirit. While Eden basked in
        favour of divine light, Elura thrived in the subtle glow of another
        dimension of existence. Elura was a paradise in the 7th dimension and a
        Divine creation—a serene balance between day and night. The first woman
        in Elura, her name was Serena. She created a collection of shiny stars
        with many colours to live for the light—a gift for her creator.
      </p>
    </>
  );
};
